import { NotFoundError } from '@/features/shared/utils/setPageProps'
import { RouteName } from '@shared/constants/routes'
import { UngatedCategoryPage } from '@/features/shop/components/UngatedCategoryPage'
import { coerceObjectValues, getSelectedParams } from '@/features/shop/services/Search/utils'
import { universalSearchQueryOptions } from '@/features/shop/services/UniversalCategories/queries'
import { createServerSidePropsHandler } from '@/features/shared/serverUtils/ssrHelpers/createServerSidePropsHandler'
import { getUniversalCategory } from '@/features/shop/services/UniversalCategories/utils'
import { fetchUserQuery } from '@/features/account/services/User/queries'
import { getPageRedirectWithZip } from '@/features/shared/serverUtils/ssrHelpers/utils'
import { getUserZip } from '@/features/account/services/User/utils'
import { getGuestStoreParamsSSR } from '@/features/shared/utils/dataFetching/guestStoreParams'
import { INFERRED_ZIP } from '@shared/constants/zip'
import { GuestDataStore } from '@/features/shared/constants/global'
import { setServerGuestCookie } from '@/features/shared/serverUtils/guest'
import { withGlobalHeaderLayout } from '@/features/shared/components/Headers/Layouts/GlobalHeaderLayout'
import { noop } from '@/features/shared/utils/noop'

export const getServerSideProps = createServerSidePropsHandler(
  RouteName.UNGATED_CATEGORY,
  async ({ queryClient, ssrContext, authContext: { isOnboarded } }) => {
    const paramsFromQuery = coerceObjectValues(ssrContext.query)
    const slug = getSelectedParams(ssrContext.query.slug ?? [])
    const currentCategory = getUniversalCategory(slug)

    // If category is not found, return a 404 error page
    if (!currentCategory?.id) {
      throw new NotFoundError('Category page not found')
    }

    const user = isOnboarded ? await fetchUserQuery(queryClient) : undefined

    const zipRedirect = getPageRedirectWithZip(ssrContext, user)
    if (zipRedirect) {
      return zipRedirect
    }

    const zip = user
      ? getUserZip(user)
      : getGuestStoreParamsSSR(ssrContext.req.cookies).guestAddress?.zip_code

    const inferredZip = ssrContext.req.cookies[INFERRED_ZIP]
    if (!zip && !user) {
      // update the guest address cookie from the inferred zip cookie
      if (inferredZip) {
        // set the guest address cookie
        setServerGuestCookie({
          name: GuestDataStore.ADDRESS,
          value: {
            zip_code: inferredZip,
          },
          ssrContext,
        })
      }
    }

    const pageQuery = ssrContext.query['page']
    const page = pageQuery && !isNaN(+pageQuery) ? +pageQuery : 1

    // Fetch universal products
    await queryClient
      .query(
        universalSearchQueryOptions({
          zip: zip ?? inferredZip,
          ...paramsFromQuery,
          category_id: currentCategory.id,
          pageParam: page,
        }),
      )
      .catch(noop)

    return {}
  },
)

export default withGlobalHeaderLayout(UngatedCategoryPage, {
  excludeSubheader: true,
})
